<template>
  <b-modal
    id="modal-preview-email-weekly"
    header-bg-variant="primary"
    size="xl"
    scrollable
    centered
    no-close-on-esc
    no-close-on-backdrop
    :title="$t('dashboard.scheduler.action.preview')"
  >
    <div>
      <p v-html="emailBody"></p>
      <hr />
    </div>
    <div class="me-email-body">
      <div class="me-email-wrapper">
        <div class="me-email-header">
          <div>
            <h1 class="me-email-logo">
              <img
                ref="imgPrimaryLogoMax"
                :src="getAsset('primaryLogo', 'login')"
                alt
                class="me-email-logo-img"
              />
            </h1>
            <span v-show="!isWhitelabel() && !isMetrack()" class="me-email-link"
              >www.mceasy.com</span
            >
            <div class="me-email-clearfix"></div>
          </div>
          <h4 class="me-email-header-title">
            {{ $t('dashboard.scheduler.preview.operationalSummary') }}
          </h4>
          <span class="me-email-header-date">{{ $t('dashboard.scheduler.preview.date') }}</span>
        </div>
        <!-- Content -->
        <div class="me-email-list me-email-list--two">
          <div class="me-email-list-item me-email-text--center">
            <p class="me-email-list-item-title">
              {{ $t('dashboard.scheduler.previewWeekly.totalDistance') }}
            </p>
            <div>
              <h4 class="me-email-number">20.000</h4>
              <span class="me-email-text-small">{{
                $t('dashboard.scheduler.previewWeekly.km')
              }}</span>
              <p class="me-email-text">
                <span class="me-email-text--green">+32%</span>
                {{ $t('dashboard.scheduler.previewWeekly.fromLastWeek') }}
              </p>
            </div>
          </div>
          <div class="me-email-list-item me-email-text--center">
            <p class="me-email-list-item-title">
              {{ $t('dashboard.scheduler.previewWeekly.totalTrip') }}
            </p>
            <div>
              <h4 class="me-email-number">324</h4>
              <span class="me-email-text-small">Trip</span>
              <p class="me-email-text">
                <span class="me-email-text--green">+2%</span>
                {{ $t('dashboard.scheduler.previewWeekly.fromLastWeek') }}
              </p>
            </div>
          </div>
          <div class="me-email-list-item me-email-text--center">
            <p class="me-email-list-item-title">
              {{ $t('dashboard.scheduler.previewWeekly.totalVehiclesRunning') }}
            </p>
            <div>
              <h4 class="me-email-number">32</h4>
              <span class="me-email-text-small"
                >{{ $t('dashboard.scheduler.previewWeekly.totalFleet') }} 35</span
              >
              <p class="me-email-text">
                <span class="me-email-text--green">+2%</span>
                {{ $t('dashboard.scheduler.previewWeekly.fromLastWeek') }}
              </p>
            </div>
          </div>
          <div class="me-email-list-item me-email-text--center">
            <p class="me-email-list-item-title">
              {{ $t('dashboard.scheduler.previewWeekly.estimatedFuelUsage') }}
            </p>
            <div>
              <h4 class="me-email-number">4.300</h4>
              <span class="me-email-text-small">Liter</span>
              <p class="me-email-text">
                <span class="me-email-text--red">-2%</span>
                {{ $t('dashboard.scheduler.previewWeekly.fromLastWeek') }}
              </p>
            </div>
          </div>
          <div class="me-email-clearfix"></div>
        </div>

        <div class="me-email-list">
          <div class="me-email-list-item">
            <p class="me-email-list-item-title">
              {{ $t('dashboard.scheduler.previewWeekly.numberOfGeofencesVisited') }}
            </p>
            <div>
              <div class="me-email-list-item-wrapper">
                <div class="me-email-list-item">
                  <div class="me-email-list-item__value me-email-list-item__value--geofence">
                    <div class="me-email-list-item-30 me-email-text--center" style="width: 120px">
                      <h4 class="me-email-number me-email-text--navy">200</h4>
                      <span class="me-email-text--small">Geofence</span>
                    </div>
                    <div class="me-email-list-item-70">
                      <p class="me-email-text-result me-email-text--red">-25</p>
                      <p>{{ $t('dashboard.scheduler.previewWeekly.fromLastWeek') }}</p>
                    </div>
                    <div class="me-email-clearfix"></div>
                  </div>
                  <table class="me-email-table">
                    <tr>
                      <th width="65%">
                        {{ $t('dashboard.scheduler.previewWeekly.topGeofencesVisited') }}
                      </th>
                      <th width="35%">
                        {{ $t('dashboard.scheduler.previewWeekly.numberOfVisits') }}
                      </th>
                    </tr>

                    <tr>
                      <td>
                        <i class="me-email-table-color" style="background-color: #082957"></i>Gudang
                        Waru 01
                      </td>
                      <td>50</td>
                    </tr>
                    <tr>
                      <td>
                        <i class="me-email-table-color" style="background-color: #082957"></i>Gudang
                        Waru 02
                      </td>
                      <td>45</td>
                    </tr>
                    <tr>
                      <td>
                        <i class="me-email-table-color" style="background-color: #114683"></i>Drop
                        Point PT Adi Kusuma
                      </td>
                      <td>40</td>
                    </tr>
                    <tr>
                      <td>
                        <i class="me-email-table-color" style="background-color: #1c74da"></i>Drop
                        Point PT Kuncoro
                      </td>
                      <td>38</td>
                    </tr>
                    <tr>
                      <td>
                        <i class="me-email-table-color" style="background-color: #4990e1"></i>Drop
                        Point PT Asingga
                      </td>
                      <td>35</td>
                    </tr>
                    <tr>
                      <td>
                        <i class="me-email-table-color" style="background-color: #77ace9"></i>Gudang
                        Persiapan 3
                      </td>
                      <td>33</td>
                    </tr>
                    <tr>
                      <td>
                        <i class="me-email-table-color" style="background-color: #0b4a33"></i>Titik
                        Singgah Sidoarjo
                      </td>
                      <td>33</td>
                    </tr>
                    <tr>
                      <td>
                        <i class="me-email-table-color" style="background-color: #137c55"></i>Gudang
                        Taman Pilang
                      </td>
                      <td>32</td>
                    </tr>
                    <tr>
                      <td>
                        <i class="me-email-table-color" style="background-color: #429677"></i>Gudang
                        Point PT Kyco
                      </td>
                      <td>30</td>
                    </tr>
                    <tr>
                      <td>
                        <i class="me-email-table-color" style="background-color: #71b099"></i>Gudang
                        Singgah Waru Timur
                      </td>
                      <td>20</td>
                    </tr>
                  </table>
                </div>
                <div class="me-email-clearfix"></div>
              </div>
            </div>
          </div>
          <div class="me-email-list-item">
            <p class="me-email-list-item-title">
              {{ $t('dashboard.scheduler.previewWeekly.vehicleUsageTrends') }}
            </p>
            <div class="me-email-chart">
              <img src="@/assets/images/emaildigest/vehicle-trend.png" alt />
            </div>
            <div class="me-email-chart me-email-pt">
              <img src="@/assets/images/emaildigest/vehicle-trend-total.png" alt />
            </div>
          </div>
        </div>

        <div class="me-email-list me-email-text--center me-email-list--two">
          <div class="me-email-list-item">
            <p class="me-email-list-item-title">
              {{ $t('dashboard.scheduler.previewWeekly.totalSilenceEngine') }}
            </p>
            <div>
              <h4 class="me-email-number">32</h4>
              <p class="me-email-text">
                <span class="me-email-text--green">+2%</span>
                {{ $t('dashboard.scheduler.previewWeekly.fromLastWeek') }}
              </p>
            </div>
            <div class="me-email-my me-email-pt me-email-border-top">
              <span class="me-email-text-small">{{
                $t('dashboard.scheduler.previewWeekly.totalSilence')
              }}</span>
              <p class="me-email-text">4 Jam 15 Menit 45 Detik</p>
            </div>
            <div class="me-email-text--center">
              <span class="me-email-text-small">{{
                $t('dashboard.scheduler.previewWeekly.totalEngineIsOn')
              }}</span>
              <p class="me-email-text">4 Jam 15 Menit 45 Detik</p>
            </div>
          </div>
          <div class="me-email-list-item">
            <p class="me-email-list-item-title">
              {{ $t('dashboard.scheduler.previewWeekly.driverAssessment') }}
            </p>
            <div style="margin: 34px 0 35px 0">
              <span class="me-email-text-small">{{
                $t('dashboard.scheduler.previewWeekly.bestDriver')
              }}</span>
              <p class="me-email-list-item-title me-email-my--0">Dimas Fariz</p>
              <p class="me-email-list-item-title" style="margin: 9px 0 0 0">
                <i class="me-email-status--rounded me-email-status--rounded-blue">A</i>
                95
              </p>
            </div>
            <div>
              <span class="me-email-text-small">{{
                $t('dashboard.scheduler.previewWeekly.worstDriver')
              }}</span>
              <p class="me-email-list-item-title me-email-my--0">Pras Perkasa</p>
              <p class="me-email-list-item-title" style="margin: 9px 0 0 0">
                <i class="me-email-status--rounded me-email-status--rounded-red">E</i>
                95
              </p>
            </div>
          </div>
          <div class="me-email-clearfix"></div>
        </div>

        <div class="me-email-list">
          <div class="me-email-list-item">
            <p class="me-email-list-item-title">
              {{ $t('dashboard.scheduler.previewWeekly.notificationsGeneral') }}
            </p>
            <div>
              <div class="me-email-list-item-half">
                <div class="me-email-chart">
                  <img src="@/assets/images/emaildigest/general-notification.png" alt />
                </div>
              </div>
              <div class="me-email-list-item-half">
                <table class="me-email-table">
                  <tr>
                    <th width="60%">{{ $t('dashboard.scheduler.previewWeekly.notifications') }}</th>
                    <th class="me-email-text--center">M3</th>
                    <th class="me-email-text--center">M4</th>
                    <th class="me-email-text--center">M1</th>
                    <th
                      style="background-color: #a4c7f0; color: #01133d"
                      class="me-email-text--center"
                    >
                      M2
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <i class="me-email-table-color" style="background-color: #ff8a00"></i
                      >{{ $t('dashboard.scheduler.previewWeekly.gpsRelease') }}
                    </td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center" style="background-color: #deeafc">20</td>
                  </tr>
                  <tr>
                    <td>
                      <i class="me-email-table-color" style="background-color: #1c74da"></i
                      >{{ $t('dashboard.scheduler.previewWeekly.exceedingIdleTimeLimit') }}
                    </td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center" style="background-color: #deeafc">20</td>
                  </tr>
                  <tr>
                    <td>
                      <i class="me-email-table-color" style="background-color: #082957"></i
                      >{{ $t('dashboard.scheduler.previewWeekly.exceedingTheParkingTimeLimit') }}
                    </td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center" style="background-color: #deeafc">20</td>
                  </tr>
                </table>
              </div>
              <div class="me-email-clearfix"></div>
            </div>
          </div>
          <div class="me-email-list-item">
            <p class="me-email-list-item-title">
              {{ $t('dashboard.scheduler.previewWeekly.notificationsDriverBehavior') }}
            </p>
            <div>
              <div class="me-email-list-item-half">
                <table class="me-email-table">
                  <tr>
                    <th width="60%">{{ $t('dashboard.scheduler.previewWeekly.notifications') }}</th>
                    <th class="me-email-text--center">M3</th>
                    <th class="me-email-text--center">M4</th>
                    <th class="me-email-text--center">M1</th>
                    <th
                      style="background-color: #a4c7f0; color: #01133d"
                      class="me-email-text--center"
                    >
                      M2
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <i class="me-email-table-color" style="background-color: #429677"></i
                      >{{ $t('dashboard.scheduler.previewWeekly.suddenAcceleration') }}
                    </td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center" style="background-color: #deeafc">20</td>
                  </tr>
                  <tr>
                    <td>
                      <i class="me-email-table-color" style="background-color: #ffa133"></i
                      >{{ $t('dashboard.scheduler.previewWeekly.suddenSlowdown') }}
                    </td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center" style="background-color: #deeafc">20</td>
                  </tr>
                  <tr>
                    <td>
                      <i class="me-email-table-color" style="background-color: #1c74da"></i
                      >{{ $t('dashboard.scheduler.previewWeekly.speed​​exceedsLimit') }}
                    </td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center" style="background-color: #deeafc">20</td>
                  </tr>
                  <tr>
                    <td>
                      <i class="me-email-table-color" style="background-color: #082957"></i
                      >{{ $t('dashboard.scheduler.previewWeekly.sharpTurn') }}
                    </td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center">20</td>
                    <td align="center" style="background-color: #deeafc">20</td>
                  </tr>
                </table>
              </div>
              <div class="me-email-list-item-half">
                <div class="me-email-chart" style="padding-left: 30px">
                  <img src="@/assets/images/emaildigest/driver-notification.png" alt />
                </div>
              </div>
              <div class="me-email-clearfix"></div>
            </div>
          </div>
        </div>
        <!-- End Content -->
        <div class="me-email-footer" v-show="!isWhitelabel() && !isMetrack()">
          <table width="100%">
            <tr>
              <td colspan="2" align="center">
                <table align="center" width="100%">
                  <tr>
                    <td align="center">
                      <h4
                        style="
                          font-size: 16px;
                          margin: 0;
                          color: #01133d;
                          font-weight: 500;
                          line-height: 1.8;
                        "
                      >
                        {{ $t('dashboard.scheduler.previewDaily.footer.text') }} <br />{{
                          $t('dashboard.scheduler.previewDaily.footer.text2')
                        }}
                        <a
                          href="https://wa.me/6281233504586"
                          target="_blank"
                          style="color: #0d4491; text-decoration: underline"
                          >{{ $t('dashboard.scheduler.previewDaily.footer.inHere') }}</a
                        >
                      </h4>
                    </td>
                  </tr>
                  <tr>
                    <td height="20">&nbsp;</td>
                  </tr>
                  <tr>
                    <td align="center">
                      {{ $t('dashboard.scheduler.previewDaily.footer.follow') }}
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td align="center">
                      <a
                        href="https://www.facebook.com/mceasy.id"
                        target="_blank"
                        style="text-decoration: none; margin-right: 15px"
                      >
                        <img
                          style="border-radius: 5px"
                          alt="Facebook"
                          src="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/email/logo_facebook_square.png"
                        />
                      </a>
                      <a
                        href="https://www.linkedin.com/company/mceasy/"
                        target="_blank"
                        style="text-decoration: none; margin-right: 15px"
                      >
                        <img
                          style="border-radius: 5px"
                          alt="Linkedin"
                          src="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/email/logo_linked_in_square.png"
                        />
                      </a>

                      <a
                        href="https://www.youtube.com/@McEasy"
                        target="_blank"
                        style="text-decoration: none; margin-right: 15px"
                      >
                        <img
                          style="border-radius: 5px"
                          alt="Youtube"
                          src="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/email/logo_youtube_square.png"
                        />
                      </a>

                      <a
                        href="https://www.instagram.com/mceasy.id/"
                        target="_blank"
                        style="text-decoration: none"
                      >
                        <img
                          style="border-radius: 5px"
                          alt="Instagram"
                          src="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/email/logo_instagram_square.png"
                        />
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td height="20">&nbsp;</td>
                  </tr>
                  <tr>
                    <td align="center">
                      {{ $t('dashboard.scheduler.previewDaily.footer.download') }}
                    </td>
                  </tr>
                  <tr>
                    <td height="10">&nbsp;</td>
                  </tr>
                  <tr>
                    <td align="center">
                      <a
                        href="https://apps.apple.com/id/app/mceasy-platform/id6450102428"
                        target="_blank"
                        class="me-email-logo-download me-email-logo-download-first"
                      >
                        <img
                          alt="App Store"
                          src="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/email/logo_download_appstore.png"
                          class="me-email-logo-download-img"
                        />
                      </a>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.mceasy.vsms&pcampaignid=web_share"
                        target="_blank"
                        class="me-email-logo-download"
                      >
                        <img
                          alt="Google Play"
                          class="me-email-logo-download-img"
                          src="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/email/logo_download_googleplay.png"
                        />
                      </a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div>
      <hr />
      <b-alert show variant="primary" class="mc-alert mt-3">
        <span class="mc-alert__text">
          {{ alertContent }}
        </span>
      </b-alert>
    </div>

    <template #modal-footer="{ cancel }">
      <b-row class="modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="modal__filter-footer-btn">
          <McButton
            variant="primary"
            class="me-2"
            :text="$t('global.action.close')"
            @click="cancel"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import { mapGetters } from 'vuex'

export default {
  components: {
    McButton,
  },
  data() {
    return {
      emailBody:
        '<p>Dear Team,</p> <br/> <p>Berikut ini merupakan summary reminder untuk PT Buana Indah</p>',
      alertContent: null,
    }
  },
  computed: {
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
      getAsset: 'asset/getAsset',
    }),
  },
  methods: {
    showModal(content, alert) {
      if (content != null) this.emailBody = content
      this.alertContent = alert
      this.$bvModal.show('modal-preview-email-weekly')
    },
    hideModal() {
      this.$bvModal.hide('modal-preview-email-weekly')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './modal-digest.scss';
</style>
